import { MatDialogConfig } from '@angular/material/dialog';
import { MessageDialogData } from './message-dialog-data';

export class ErrorDialogConfig extends MatDialogConfig<MessageDialogData> {
  override restoreFocus?: boolean | undefined = false;
  constructor(
    message = 'Si è verificato un errore generico, riprova più tardi.',
    title = 'Errore'
  ) {
    super();
    this.data = {
      title: title,
      message: message,
      buttonConfirmText: 'Ok',
      confirmButtonColor: 'warn',
    };
  }
}
